export default __webpack_public_path__ + "static/17-3b517e94fcf243668ef3347644cc0fb7.webp";